import styled from 'styled-components'

import { white, red, black } from '../../styles/colors'
import { minmedia } from '../../styles/media-queries'

export const Container = styled.div`
  background-image: url(${props => props.mobileImage});
  ${minmedia.medium`
    background-image: url(${props => props.image});
  `};
  background-size: cover;
  background-position: center;
  padding: 2rem 0;
  ${minmedia.medium`
    padding: 6rem 0;
  `};

`
export const Wrapper = styled.div`
  position: relative;
  max-width: 92%;
  width: 1600px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

export const Title = styled.div`
  font-size: 24px;
  color: ${white};
  font-weight: 800;
  text-transform: uppercase;
  margin: 0 auto;
  margin-bottom: 2rem;
  line-height: 1.5;
  max-width: 500px;
  ${minmedia.medium`
    text-align: center;
    width: 350px;
  `};
  ${minmedia.xmlarge`
    font-size: 64px;
    font-weight: 800;
    max-width: 50%;
    line-height: 1;
    width: 550px;
    text-align: left;
    margin-bottom: 0;
  `};
`

export const ContentContainer = styled.div`
  width: 100%;
  ${minmedia.xmlarge`
    width: calc(100% - 550px);
  `};
`

export const ContentWrapper = styled.div`
  background: ${white};
  max-width: 100%;
  width: 500px;
  padding: 2rem;
  border-radius: 0.25rem;
  margin: 0 auto;
  ${minmedia.xmlarge`
    padding: 3rem 4rem;
    width: 550px;
  `};
`

export const Content = styled.div`
  p {
    margin-bottom: 2rem;
  }
`

export const Button = styled.a`
  transition: all 0.5s;
  display: inline-block;
  border: 1px solid ${red};
  color: ${black};
  padding: 0.75rem 2rem;
  text-decoration: none;
  border-radius: 0.25rem;
  font-weight: 300;
  &:hover {
    background: ${red};
    color: ${white};
  }
`



// WEBPACK FOOTER //
// ./src/components/FullScreenCTA/styles.js